(() => {
  'use strict';

  const revealEditorState = root => {
    if (!window.Shopify?.designMode) return;
    const roots = root?.matches?.('[data-pw16-story-editor]')
      ? [root]
      : [...(root?.querySelectorAll?.('[data-pw16-story-editor]') || [])];
    roots.forEach(section => {
      section.hidden = false;
      section.classList.add('is-mounted');
    });
  };

  const setPremiumVideoFit = media => {
    if (!media?.matches?.('[data-pw15-story-media]')) return;
    const video = media.querySelector('video');
    if (!video) {
      media.classList.remove('pw16-video-fit');
      media.style.removeProperty('--pw16-video-poster');
      return;
    }

    media.classList.add('pw16-video-fit');
    media.dataset.fit = 'contain';

    const poster = video.poster || video.getAttribute('poster') || '';
    if (poster) {
      const safePoster = poster.replace(/\\/g, '%5C').replace(/"/g, '%22').replace(/[\n\r]/g, '');
      media.style.setProperty('--pw16-video-poster', `url("${safePoster}")`);
    } else {
      media.style.removeProperty('--pw16-video-poster');
    }
  };

  const syncPremiumVideoFits = root => {
    const mediaNodes = root?.matches?.('[data-pw15-story-media]')
      ? [root]
      : [...(root?.querySelectorAll?.('[data-pw15-story-media]') || [])];
    mediaNodes.forEach(setPremiumVideoFit);
  };

  document.addEventListener('shopify:section:load', event => {
    revealEditorState(event.target);
    syncPremiumVideoFits(event.target);
  });

  document.addEventListener('shopify:block:select', event => {
    const blockId = event.detail?.blockId;
    if (!blockId) return;
    const card = [...document.querySelectorAll('[data-pw15-block-id]')].find(item => item.dataset.pw15BlockId === blockId);
    if (card) return;
    document.querySelector('[data-pw16-story-editor] .pw16-product-story-editor__help')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      const targetMedia = mutation.target?.closest?.('[data-pw15-story-media]');
      if (targetMedia) setPremiumVideoFit(targetMedia);
      mutation.addedNodes.forEach(node => {
        if (node.nodeType !== Node.ELEMENT_NODE) return;
        if (node.matches?.('[data-pw15-story-media]')) setPremiumVideoFit(node);
        const parentMedia = node.closest?.('[data-pw15-story-media]');
        if (parentMedia) setPremiumVideoFit(parentMedia);
        syncPremiumVideoFits(node);
      });
    });
  });

  const init = () => {
    revealEditorState(document);
    syncPremiumVideoFits(document);
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['poster', 'src']
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
